import { Component, OnInit, Input } from '@angular/core'
import { Rental } from '@tokeet-frontend/tv3-platform'
import { CalendarEvent, CalendarEventTypesMapping } from '@tv3/store/calendar/calendar.model'

@Component({
  selector: 'app-hold-event-tooltip-popup',
  templateUrl: './hold-event-tooltip-popup.component.html',
  styleUrls: ['./hold-event-tooltip-popup.component.scss'],
})
export class HoldEventTooltipPopupComponent implements OnInit {
  @Input() event: CalendarEvent
  @Input() rental: Rental

  get eventType() {
    return CalendarEventTypesMapping[this.event?.type]
  }

  constructor() {}
  ngOnInit(): void {}
}
